import { ReactNode } from 'react';
import styles from './AboutUsSiteContainer.module.css';

interface Props {
  wider?: boolean;
  withVerticalGaps?: boolean;
  positionRelative?: boolean;
  children: ReactNode;
}

const AboutUsSiteContainer = (props: Props) => (
  <div
    className={
      styles.siteContainer +
      ' ' +
      (props.wider ? styles.wider : '') +
      ' ' +
      (props.withVerticalGaps ? styles.withVerticalGaps : '') +
      ' ' +
      (props.positionRelative ? styles.positionRelative : '')
    }
  >
    {props.children}
  </div>
);

export default AboutUsSiteContainer;
